type Props = {
    text: string
    clazz?: string
  };

function Title({text, clazz = 'text-3xl'}: Props) {
    return <h1 className={`duration-1000 ease-in-out ${clazz} md:text-5xl font-extralight text-left text-slate-700/[.85]`} >{text}</h1>;
};

export default Title;